import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { store } from "./redux/storeConfig/store";
import { authContext, getGroups } from "./authetication/adal-config";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.2.0";
import "assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import perfil from "./views/Perfil";

import AdminLayout from "layouts/Admin.js";
import * as serviceWorker from "./serviceWorkerRegistration";
import { msalConfig } from "./authetication/authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import Events from "./views/Events";


const hist = createBrowserHistory();
// Handle possible callbacks on id_token or access_token
authContext.handleWindowCallback();
const msalInstance = new PublicClientApplication(msalConfig);

const getIp = () => {
  fetch("https://api.ipify.org?format=json")
    .then((response) => response.json())
    .then((data) => {
      localStorage.setItem("ip", data.ip);
    })
    .catch((error) => {
      console.log("Erro ao obter o IP:", error);
    });
};
getIp();
serviceWorker.register();

msalInstance.addEventCallback(
  (event) => {
    // set active account after redirect
    if (event.eventType === "msal:loginSuccess" && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
      localStorage.setItem("account", JSON.stringify(account));
      localStorage.setItem("teste", event.payload.accessToken);
      getGroups(msalInstance);
    }
  },
  (error) => {
    console.log("error", error);
  }
);

// Extra callback logic, only in the actual application, not in iframes in the app
if (
  window === window.parent &&
  window === window.top &&
  !authContext.isCallback(window.location.hash)
) {
  // Having both of these checks is to prevent having a token in localstorage, but no user.
  if (!msalInstance.getAllAccounts().length > 0) {
    msalInstance.addEventCallback(
      (event) => {
        // set active account after redirect
        if (event.eventType === "msal:loginSuccess" && event.payload.account) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
          localStorage.setItem("account", JSON.stringify(account));
          localStorage.setItem("teste", event.payload.accessToken);
          console.log('entoru aqui')
          getGroups(msalInstance);
          window.location.reload();
        }
      },
      (error) => {
        console.log("error", error);
      }
    );

    console.log("get active account", msalInstance.getActiveAccount());

    msalInstance
      .handleRedirectPromise()
      .then((authResult) => {
        console.log("authResult", authResult);
        const account = msalInstance.getActiveAccount();
        if (!account) {
          console.log("No active account found. Please login");
          msalInstance.loginRedirect({
            prompt: "login",
          });
        }
      })
      .catch((err) => {
        // TODO: Handle errors
        console.log(err);
      });
    // or render something that everyone can see
    // ReactDOM.render(<PublicPartOfApp />, document.getElementById('root'))
  } else {
    ReactDOM.render(
      <Provider store={store}>
        <Router history={hist}>
          <Switch>
            <Route
              path="/admin"
              render={(props) => <AdminLayout {...props} />}
            />
            <Route path="" component={perfil} />
            <Route path="/events/events" component={Events} />
          </Switch>
        </Router>
      </Provider>,
      document.getElementById("root")
    );
  }
}
